﻿import { Spin, Typography } from "antd";
import { useState } from "react";
import { useIntl } from "react-intl";

const { Text } = Typography;

interface IProps {
  values: string[];
  type?: string;
  loading?: boolean;
}

const DisplayedValues = ({ values, type, loading }: IProps) => {
  const intl = useIntl();

  const [unknown] = useState(() => {
    let value = intl.formatMessage({ id: "general.unknown" });

    if (type) {
      value += ` ${type}`;
    }

    return value;
  });

  if (loading) return <Spin size="small" />;

  if (!values?.length)
    return (
      <Text type="secondary">{intl.formatMessage({ id: "general.none" })}</Text>
    );

  if (values.length === 1) return values[0] || unknown;

  return (
    <ul>
      {values.map((value, index) => (
        <li key={value || index}>{value || unknown}</li>
      ))}
    </ul>
  );
};

export default DisplayedValues;
